module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMiIgZmlsbD0iIzkxQzg1NSIvPjxwYXRoIGQ9Ik0xNyA4LjVsLTYuNzg2IDdMNyAxMi43IiBzdHJva2U9IiNmZmYiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/checkbox-checked_old.svg
// module id = 1674
// module chunks = 5